import Agent from '../agent'
import knbUse from '../knb/knb-use'
import { getStatisticUrl } from '../query'
import { mpNavigateTo, mpRedirectTo, mpNavigateBack } from './mp-base'
import { mpWebviewMap } from './mp-const'
import jump2filter from './jump2filter'
import jump2housing from './jump2housing'
import jump2client from './jump2client'
import jump2hostProfile from './jump2hostProfile'
import jump2submitOrder from './jump2submitOrder'
import { copy } from '../clipboard'
import { reportError, reportInfo } from '../owl'
import { lxMC } from '../lx'

export { jump2filter, jump2housing, jump2client, jump2hostProfile, jump2submitOrder }

function transCubeLink(url: string) {
  if (Agent.weixin && url.indexOf('https://i.meituan.com/awp/hfe/block/index.html') === 0) {
    try {
      const searchParams = new URL(url).searchParams
      const cube_i = searchParams.get('cube_i')
      const cube_h = searchParams.get('cube_h')
      if (cube_i && cube_h) {
        let path = url.split('?')[0] || ''
        path = path.replace('fe/block/index.html', 'fe/block/' + cube_h + '/' + cube_i + '/index.html')
        searchParams.delete('cube_i')
        searchParams.delete('cube_h')
        return path + '?' + searchParams.toString()
      }
    } catch (e) {
      reportError({
        name: '转换链接出错',
        msg: e,
      })
    }
  }
  return url
}

function processUrl(url: string) {
  const hasHost = url.indexOf('http') === 0 || url.indexOf('://') !== -1
  const newUrl = `${hasHost ? '' : document.location.origin}${url}`
  return getStatisticUrl(transCubeLink(newUrl))
}

export function validateWhiteDomain(url: string) {
  // 只有 App 和小程序才需要较验
  if (Agent.android_Ios_HarmonyNative || Agent.anyminiprogram) {
    if (/^(iaphx|imeituan|dianping):\/\//.test(url)) {
      return true
    }
    const host = new URL(url).host
    return /meituan.com|sankuai.com|dianping.com$/.test(host)
  } else {
    return true
  }
}

/**
 * [pushPage 跳转到指定url,在knb环境下会打开一个新的webview]
 * https://sky.sankuai.com/schema
 * @param  {[String]} url
 * @param  {[Object]} options [配置]
 */
export function pushPage(
  url: string,
  _options: {
    appnm?: string
  } = {},
) {
  if (!url) {
    reportError({
      name: 'PUSH_PAGE',
      msg: '链接没配',
    })
    return false
  }
  if (!validateWhiteDomain(url)) {
    if (Agent.android_Ios_HarmonyNative) {
      window.location.href = url
      return true
    } else {
      copy(url).then(
        () => {
          window.$toasted.show('链接已复制，可在浏览器打开')
        },
        () => {
          window.$toasted.show('链接不支持当前环境访问，可前往App访问')
        },
      )
      reportInfo({
        name: '域名不在白名单',
        msg: url,
        global: true,
      })
      return false
    }
  }
  const options = { notitlebar: false, hideShareMenu: false, ..._options }
  const iUrl = processUrl(url)
  if (Agent.android_Ios_HarmonyNative) {
    let query: {
      notitlebar?: number
      _knbopeninapp: number
    } = { _knbopeninapp: 1 }
    if (options.notitlebar) {
      query = { notitlebar: 1, _knbopeninapp: 1 } // 隐藏webview的导航栏功能
    }
    knbUse('openPage', { url: iUrl, query })
    return true
  }
  if (Agent.anyminiprogram) {
    const { appnm } = options
    const path = mpWebviewMap(iUrl, { appnm })
    if (path) {
      mpNavigateTo(path, options)
    } else {
      document.location.href = iUrl
    }
    return
  }
  if (Agent.pc) {
    window.open(iUrl, '_blank')
    return true
  }
  document.location.href = iUrl
  return true
}

/**
 * [replacePage 替换当前页面，在knb环境下会关闭当前webview,并打开一个新的webview]
 * @param  {[String]} url
 * @param  {[Object]} options [配置]
 */
export function replacePage(
  url: string,
  _options: {
    appnm?: string
  } = {},
) {
  if (!url) {
    reportError({
      name: 'REPLACE_PAGE',
      msg: '链接没配',
      global: true,
    })
    return
  }
  const options = { notitlebar: false, hideShareMenu: false, ..._options }
  const iUrl = processUrl(url)
  if (Agent.android_Ios_HarmonyNative) {
    let query: {
      notitlebar?: number
      _knbopeninapp: number
    } = { _knbopeninapp: 1 }
    if (options.notitlebar) {
      query = { notitlebar: 1, _knbopeninapp: 1 } // 隐藏webview的导航栏功能
    }
    knbUse('jumpPage', { url: iUrl, query })
    return
  }
  if (Agent.anyminiprogram) {
    const { appnm } = options
    const path = mpWebviewMap(iUrl, { appnm })
    if (path) {
      mpRedirectTo(mpWebviewMap(iUrl), options)
    } else {
      window.location.replace(iUrl)
    }
    return
  }
  window.location.replace(iUrl)
}

export function navigateBack({ fallback, timeout }: { fallback?: Function; timeout?: number } = {}) {
  lxMC('b_fqbss9oz')
  function callFallback() {
    clearTimeout(i)
    fallback && fallback()
  }

  const i = setTimeout(callFallback, timeout || 2000)
  if (Agent.anyminiprogram) {
    clearTimeout(i)
    mpNavigateBack()
    return
  }
  if (Agent.weixin) {
    knbUse('closeWindow')
    return
  }
  if (Agent.android_Ios_HarmonyNative) {
    knbUse('closePage', { fail: callFallback })
    return
  }
  if (typeof fallback === 'function') {
    callFallback()
    return
  }
  window.history.back()
}
